module.exports = __webpack_public_path__ + "img/usaid-logo.689fc93e.png";